import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Grid from '@material-ui/core/Grid';
import { astriskStyle } from 'src/styles/CommonStyles.styled';

export const AccountGridContainer = styled(Grid)`
    width: 100%;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    opacity: 1;
    margin-top: 10px;
    margin-bottom: 2px;
    padding: ${({ isFromEquity }) =>
        isFromEquity ? '20px 20px' : '20px'};
    // padding-right: 16px;
    // padding-left: 16px;
    ${media.mobileDevice`
    width: auto;
     padding: ${({ isFromEquity, isFromConsignmentBilling }) =>
        isFromEquity ? '15px 18px' : isFromConsignmentBilling ? '20px 24px' : ''};
     margin-top: ${({ isCondensedView, isFromConsignmentAdd }) =>
        isFromConsignmentAdd ? (isCondensedView ? '10px' : '10px') : '10px'};
    `}
    ${media.mediumDevice`
    width: auto;
    `}
    ${media.smalDevice`
    width: auto;
    `}
`;

export const AccountGrid = styled(Grid)``;

export const AccountTitle = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 18px;
    color: #140f4b;
    display: flex;
    justify-content: space-between;
    letter-spacing: 0px;
    opacity: 1;
    text-align: left;
    // margin-left: 20px;
    // margin-top: 14px;
    ${media.mediumDevice`
        
    `}
    ${media.smalDevice`
        
    `}
    ${media.mobileDevice`    
   // font-size: 15px;
    `}
`;

export const AccountDetails = styled.div`
    text-align: left;
    font-family: ${({ isRegular, isDemi, isItalic }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi
            ? 'AvenirNextWorld Demi'
            : isItalic && 'AvenirNextWorld italic'};
    font-size: ${({ isDemi }) => (isDemi ? '14px' : '16px')};
    color: #202124;
    opacity: 1;
    // margin-left: 20px;
    &:after {
        content: '${(props) => (props.showAstrisk ? ' *' : '')}';
        color: #ef162b;
    }
    ${media.mobileDevice`
    // margin-left: 22px;
    //font-size: ${({ isDemi }) => (isDemi ? '14px' : '15px')};
    `}
    ${media.mediumDevice`
    // margin-left: 22px; 
    `}
    ${media.smalDevice`
    // margin-left: 22px; 
    `}
`;

export const DetailsMainContainerBlock = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: ${({ justifyContent }) =>
        justifyContent ? justifyContent : 'space-between'};

    ${media.mobileDevice`
        width: 90%;
        margin: 0px auto;
        padding: ${({ mbPadding }) => (mbPadding ? mbPadding : ' ')};
        flex-direction: column;
    `}
`;

export const NotesContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: ${({ margin }) => (margin ? margin : '10px 10px 10px 0px')};
    width: 100%;
    word-break: break-word;
    ${media.mobileDevice`
        margin:15px 0 0 -20px;
        width: 100%;
    `};
`;

export const MainContainerItems = styled.div`
    width: ${({ setWidth }) => (setWidth ? setWidth : '47%')};
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    border-left: ${({ borderLeft }) => borderLeft};
    margin-bottom: ${({ setMarginBottom }) =>
        setMarginBottom ? '16px' : '0px'};
    padding-left: ${({ paddingLeft }) => (paddingLeft ? paddingLeft : '0px')};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0px')};

    ${media.mobileDevice`
        width:${({ mbSetWidth }) => (mbSetWidth ? mbSetWidth : '47%')};
        margin-bottom: ${({ mbMarginBottom }) => mbMarginBottom};
        margin-left: 0px;
    `}
`;

export const Subtitle = styled.div`
    font-family: ${({ font }) => (font ? font : 'AvenirNextWorld Regular')};
    color: #202124;
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '14px')};
    display: flex;
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : 'row'};
    text-transform: ${({ textTransform }) =>
        textTransform ? textTransform : ''};
    // address should come in 4 lines
    ${media.mobileDevice`
    width:${({ width }) => (width ? width : '')};
`}
`;

export const ImageContainer = styled.img`
    transform: ${({ isExpanded }) => (isExpanded ? 'rotate(180deg)' : '')};
`;

export const Title = styled.div`
    font-family: AvenirNextWorld Demi;
    color: #4f4f4f;
    font-size: 16px;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '8px'};

    ${astriskStyle};
    ${media.mobileDevice`
    margin-bottom:${({ marginBottom }) =>
        marginBottom ? marginBottom : '8px'};
`}
`;

export const ImageBox = styled.div`
    display: flex;
    align-items: center;
      ${media.mobileDevice`    
    margin: ${({ mbMargin }) => (mbMargin ? mbMargin : '')};
;
    `}
`;

export const MainTitle = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 16px;
    text-align: left;
    color: #140f4b;
    letter-spacing: -0.12px;
    opacity: 1;
    cursor: pointer;
    // margin-left: 18px;
    // margin-top: 19px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    ${media.mediumDevice`
        
    `}
    ${media.smalDevice`
        
    `}
    ${media.mobileDevice`    
        color : ${({mbColor}) => (mbColor ? mbColor : '#140f4b') };
      font-size: ${({ mbFontSize }) => (mbFontSize ? mbFontSize : '15px')};
    `}
`;

export const ImageWrapper = styled.div`
    width:${({ width }) => (width ? width : '30px')};
    height: 30px;
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    opacity: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${({ padding }) => (padding ? padding : '')};

`;

export const VerticalLineSeperator = styled.div`
    border-left: 1px solid #000000;
    opacity: 0.1;
    height: 100%;
    display: grid;
    justify-self: center;
`;

export const Bar = styled.div`
    width: 2px;
    height: 23px;
    text-align: left;
    color: #202114;
    opacity: 0.9;
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0')};
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '0')};
`;

export const NotesHorizontalLine = styled.div`
    border-top: 1px solid #dcdcdc;
    width: 100%;
    margin: ${({ margin }) => (margin ? margin : '20px 0')};
`;
